import { render, staticRenderFns } from "./NgLabel.vue?vue&type=template&id=b5421abe&scoped=true"
import script from "./NgLabel.vue?vue&type=script&lang=js"
export * from "./NgLabel.vue?vue&type=script&lang=js"
import style0 from "./NgLabel.vue?vue&type=style&index=0&id=b5421abe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5421abe",
  null
  
)

export default component.exports